import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ConfigService } from '@app-core/services';
import { AccessScope } from '@app-model/access-scopes';

import { featureKey, State } from './user.reducer';

const environment = ConfigService.getEnvironment();

export const selectUserState = createFeatureSelector<State>(featureKey);
export const selectUser = createSelector(selectUserState, (state) => state.user);
export const selectUserAccessScopes = createSelector(selectUserState, (state) => state.user?.scopes || []);
export const selectUserHasAccessScope = (scope: AccessScope) =>
  createSelector(selectUserAccessScopes, (scopes) => !!(scopes && scopes.includes(scope)));
export const selectUserHasUserManagementAccess = createSelector(
  selectUserHasAccessScope('ADMIN_DEALERSHIP_USER_MANAGEMENT'),
  selectUserHasAccessScope('ADMIN_CORPORATE_USER_MANAGEMENT'),
  (dealershipUserManagement, corporateUserManagement) =>
    environment.features.supportUserManagement && (dealershipUserManagement || corporateUserManagement)
);
export const selectCanEmulateDealer = createSelector(
  selectUserHasAccessScope('DEALER_EMULATE'),
  selectUserHasAccessScope('DEALER_EMULATE_ALL'),
  (emulate, emulateAll) => emulate || emulateAll
);
export const selectUsers = createSelector(selectUserState, (state) => state.users);
export const selectRoles = createSelector(selectUserState, (state) => state.roles);
export const selectMarkup = createSelector(selectUserState, (state) => state.markup);
export const selectAppVersion = createSelector(selectUserState, (state) => state.appVersion);
export const selectEmulatedDealer = createSelector(selectUserState, (state) => state.emulatedDealer);
export const selectPendingContracts = createSelector(selectUserState, (state) => state.pendingContracts);
export const selectRecentQuotes = createSelector(selectUserState, (state) => state.recentQuotes);
export const selectCancellationURL = createSelector(selectUserState, (state) => state.user.cancellationURL);
export const selectCmsDealerNumber = createSelector(selectUserState, (state) => state.user.cmsDealerNumber);
